// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__y1x1m"};